// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","583":"component---src-pages-privacy-policy-index-tsx"}[chunkId] || chunkId) + "-" + {"245":"e701b6d0d5a4f7d6dffe","453":"5668eedd10c2f2f859a6","522":"b8b326fbaa98079391cb","583":"d462612494e12a7f66fa"}[chunkId] + ".js";
};